import { withRouter } from 'core/withRouter';
import React, { useEffect, useRef, useState } from 'react';
import TripFeeListV from './TripFee.list.v';
import PageUtil from 'utils/Page.util';
import { TripFeeDTO, TripFeeSearchDTO } from 'models/trip-fee';
import tripFeeService from 'services/trip-fee.service';
import PageStateService from 'core/PageState.service';

class Params {
    error: string = null;
    isLoaded: boolean = false;
    items: Array<TripFeeDTO>;
    total: number = 0;

    search = new TripFeeSearchDTO();
}

function TripFeeList(props: any) {
    const [params, setParams] = useState(new Params());
    const [search, setSearch] = useState(false);
    const stateRef = useRef(new Params());

    /* ***************************************************************************************** */
    /* ************************************* STATE ********************************************* */
    /* ***************************************************************************************** */
    useEffect(() => {
        if (!search) {
            return;
        }

        if (search) {
            setSearch(false);
            getData(params.search);
        }
    }, [search]);

    // 상태 유지
    useEffect(() => {
        stateRef.current = params as any;
    }, [params]);

    // onMount
    useEffect(() => {
        const uri = location.pathname;
        let storeState = PageStateService.restorePageState(uri);

        if (storeState != null) {
            setParams(() => ({
                ...storeState,
            }));
        } else {
            setSearch(true);
        }

        return () => {
            PageStateService.savePageState(uri, stateRef.current);
        };
    }, []);

    /* ***************************************************************************************** */
    /* ************************************** PAGE ********************************************* */
    /* ***************************************************************************************** */
    function onSearch() {
        const curParams = PageUtil.deepCopy(params) as Params;

        curParams.search.page = 1;
        curParams.isLoaded = false;

        setParams(curParams);
        setSearch(true);
    }

    function onChangeRowUnit(e: any) {
        const search = PageUtil.deepCopy(params.search);

        search.rows = e.target.value;
        search.page = 1;

        setParams((prev) => ({
            ...prev,
            search: search,
        }));

        setSearch(true);
    }

    /* ***************************************************************************************** */
    /* ************************************* BASIC ********************************************* */
    /* ***************************************************************************************** */
    async function getData(search: TripFeeSearchDTO): Promise<any> {
        try {
            const res = await tripFeeService.list(search);
            console.log('res {getData}', res);

            setParams((prev) => ({
                ...prev,
                error: null,
                isLoaded: true,
                items: res.content,
                total: res.totalElements,
            }));
        } catch (error) {
            setParams((prev) => ({
                ...prev,
                isLoaded: true,
                error: error,
            }));

            PageUtil.handleApiError(error);
        }
    }

    /* ***************************************************************************************** */
    /* ************************************** VAC ********************************************** */
    /* ***************************************************************************************** */
    const args = {
        params: params,
        setParams: setParams,
        setSearch: setSearch,

        onSearch: onSearch,
        onChangeRowUnit: onChangeRowUnit,

        pageChanged: PageUtil.pageChanged,
        handleChange: PageUtil.handleChange,
    };

    return <TripFeeListV {...args} />;
}

export default withRouter(TripFeeList, [tripFeeService]);